import { render } from "./UserDrawer.vue?vue&type=template&id=12d96c11&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"

import "./UserDrawer.vue?vue&type=style&index=0&id=12d96c11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d96c11"]])

export default __exports__